
// Collection pagination

// Only run when pagination is present in the collection
function collectionPagination() {

  // abbreviating 'pagination' to 'pag'
  let pagSection = $('#collection-pagination');
  let pagProgressBar = pagSection.find('#pagination-progress-bar');
  let pagProgress = pagProgressBar.children('#pagination-progress');
  let productsViewed = pagSection.find('#products-viewed');
  let loadMoreButton = pagSection.find('#pagination-load-more');
  let collectionType = 'collection';
  if (pagSection.hasClass('search-pagination')) {
    collectionType = 'search';
  }

  var collectionTotalProducts = parseInt(pagSection.attr('data-total-products'));
  var pagStepSize = parseInt(pagSection.attr('data-pagination-step'));
  var pagTotalPages = parseInt(pagSection.attr('data-pagination-pages'));
  var productsLoaded = parseInt($('#collection-listing').find('.product-card').length);
  var filterAppliedLink = '';

  var currentPageIndex = 1;
  var nextPageUrl = pagSection.attr("data-next-page-url");
  var urlParams = nextPageUrl.split("&")[1];
  var pageToFetch = nextPageUrl.split("=")[0] + "=" + (currentPageIndex + 1) + "&" + urlParams;

  var urlFull = window.location.href; // full URL
  var pseudoPageParam = '?pg=1';
  var pseudoPageParamSymbol = '?';
  var pseudoPageParamValue = 1;
  if (urlFull.indexOf('?pg=') >= 0) {
    pseudoPageParam = '?pg=' + urlFull.split('?pg=')[1].split('/')[0].split('?')[0].split('#')[0];
    pseudoPageParamValue = parseInt(pseudoPageParam.split('=')[1]);
  }
  else if (urlFull.indexOf('&pg=') >= 0) {
    pseudoPageParam = '&pg=' + urlFull.split('&pg=')[1].split('/')[0].split('?')[0].split('#')[0];
    pseudoPageParamSymbol = '&';
    pseudoPageParamValue = parseInt(pseudoPageParam.split('=')[1]);
  }

  function countProductsLoaded() {
    productsLoaded = $('#collection-listing').find('.product-card').length;
    return productsLoaded;
  }

  // Update progress bar before ajax call by increasing by pagination step size
  function updateProgressBar() {
    var percentageViewed = 100 * (countProductsLoaded()/collectionTotalProducts);
    pagProgress.css('width', percentageViewed + '%');
  }

  // Update pseudo page parameter in URL
  function updateUrlPageParam(currentPageIndex) {
    var updatedUrl = '';
    var pseudoNextPageParam = '';
    if (urlFull.indexOf('pg=') >= 0) { // If URL has 'pg' param
      pseudoNextPageParam = pseudoPageParamSymbol + 'pg=' + currentPageIndex;
      updatedUrl = urlFull.replace(pseudoPageParam, pseudoNextPageParam);
      pseudoPageParam = pseudoNextPageParam; // update page param variable
    }
    else {
      if (urlFull.indexOf('?') >= 0) {
        pseudoPageParamSymbol = '&';
      }
      pseudoNextPageParam = pseudoPageParamSymbol + 'pg=' + currentPageIndex;
      updatedUrl = urlFull + pseudoNextPageParam;
    }
    window.history.replaceState('', '', updatedUrl); // update URL (without pushstate)
    urlFull = window.location.href; // redefine full URL
    pseudoPageParam = pseudoNextPageParam; // redefine current page param
  }

  // function productCardImageRes(productCard) {
  //   var mainImage = $(productCard).find('.inner .upper picture img');
  //   var mainImageSource = mainImage.siblings('source');
  //   var bodyShot = $(productCard).children('picture').children('img');
  //   var bodyShotSource = bodyShot.siblings('source');
  //   mainImage.attr('src', mainImage.attr('data-src'));
  //   mainImageSource.attr('srcset', mainImageSource.attr('data-srcset'));
  //   bodyShot.attr('src', bodyShot.attr('data-src'));
  //   bodyShotSource.attr('srcset', bodyShotSource.attr('data-srcset'));
  // }

  function wishlistBtnState(btn) {
    if (typeof Appmate !== 'undefined' && typeof Appmate !== null) {
      let productId = btn.attr('data-product-id');
      if (Appmate.wk.getProduct(productId) !== null) {
        btn.toggleClass('active');
      }
    }
  }






  // Check for page parameter in URL on load
  function loadMultiPageProducts(pageNumber) {

    //$('body').css('overflow-anchor', 'none'); // Ensure scroll position maintains
    var pageNumber = pageNumber || 2; // Use next page number, otherwise begin at page 2

    if(pageNumber <= pseudoPageParamValue) {
      pageToFetch = nextPageUrl.split("=")[0] + "=" + pageNumber + "&" + urlParams;
      jQuery.ajax({
        url: pageToFetch,
        success: function(result){
          let newItems = $(result).find('.product-card');
          newItems.each( function(i) {
            let newItem = $(newItems[i]).wrap( "<div class='grid-item preloaded'></div>" ); // Wrap each product-card in a grid-item
            $("#collection-listing").find('.grid').append($(newItem.parent())); // Append new wrapped item to the grid
            wishlistBtnState($(newItems[i]).find('.wishlist-add'));
          });
          lazyImages(); // Updgrade images
          // Generate payment plan hooks for all new items
          let productPaymentPlanHooks = document.querySelectorAll('.product-payment-plan-hook.loading');
          if(productPaymentPlanHooks.length > 0) {
            productPaymentPlanHooks.forEach((hook) => makeProductHummHook(hook));
          }
          // Apply event listeners for all new product overview videos
          let newGridItems = document.getElementById('collection-listing').querySelectorAll('.grid-item.preloaded');
          if(newGridItems.length > 0) {
            newGridItems.forEach((newGridItem) => productCardOverviewVideo(newGridItem.querySelector('.product-card'), true));
          }
          loadMultiPageProducts(pageNumber+1); // Call self with next page number
        }
      });
    }
    // After all AJAX load
    else {
      // Reposition scroll
      // var scrolled = $(window).scrollTop();
      // if( scrolled > parseInt($('#collection-pagination').position().top) ) {
      //   document.getElementById('collection-pagination').scrollIntoView({block: "start"});
    	// }
      // Update pagination data
      currentPageIndex = pseudoPageParamValue;
      pageToFetch = nextPageUrl.split("=")[0] + "=" + (currentPageIndex + 1) + "&" + urlParams;
      pagSection.attr('data-next-page-url', pageToFetch);
      // Update progress bar
      updateProgressBar();
      productsViewed.text(countProductsLoaded());
      // If pagination complete, apply feedback
      if (currentPageIndex == pagTotalPages) {
        loadMoreButton.fadeOut();
        // Check if filters are applied to collection
        if ($('#collection-pagination').attr('data-filter-applied') == 'true') {
          filterAppliedLink = ' with <a href="javascript:;" class="applied-filters">applied filters</a>';
        }
        pagSection.find('p').html('Viewing all ' + collectionTotalProducts + ' items in this ' + collectionType + filterAppliedLink);
      }
      allowProductPreload = true;
    }
  } // end loadMultiPageProducts()

  var allowProductPreload = true;
  if (pseudoPageParamValue > 1) {
    allowProductPreload = false; // block scroll preload until multipage product load is complete on load
    loadMultiPageProducts();
  }
  else {
    // Update progress bar and count on load
    updateProgressBar();
    productsViewed.text(countProductsLoaded());
  }







  // PRELOAD ON SCROLL
  if (pagSection.hasClass('scroll-preload') && 'IntersectionObserver' in window) { // If IntObv is compatible with browser
    // var preloadMargin = 2500; // px above/below pagination section that triggers preload
    var preloadMargin = window.innerHeight * 1.5; // px above/below pagination section that triggers preload
    preloadMargin = preloadMargin + 'px 0px'; // apply as margin-bottom to viewport
    var paginationObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && allowProductPreload == true) {
          //console.log('IntObv load');
          var paginationSection = entry.target;
          // Get data from next page of products
          $.ajax({
            url: pageToFetch,
            success: function(result) {
              // Find product-cards from next page and append
              let newItems = $(result).find('.product-card');
              newItems.each( function(i) {
                let newItem = $(newItems[i]).wrap( "<div class='grid-item new' style='display:none;'></div>" ); // Wrap each product-card in a grid-item
                //$(newItem.parent()).insertBefore($("#collection-pagination")); // Append new wrapped item to the list before pagination section
                $("#collection-listing").find('.grid').append($(newItem.parent())); // Append new wrapped item to the grid
                wishlistBtnState($(newItems[i]).find('.wishlist-add'));
                //console.log(i + '. ' + $(newItems[i]).find('h3').text());
              });
            }
          }).done(function() {
            lazyImages();
            // Generate payment plan hooks for all new items
            let productPaymentPlanHooks = document.querySelectorAll('.product-payment-plan-hook.loading');
            if(productPaymentPlanHooks.length > 0) {
              productPaymentPlanHooks.forEach((hook) => makeProductHummHook(hook));
            }
            // Apply event listeners for all new product overview videos
            let newGridItems = document.getElementById('collection-listing').querySelectorAll('.grid-item.new');
            if(newGridItems.length > 0) {
              newGridItems.forEach((newGridItem) => productCardOverviewVideo(newGridItem.querySelector('.product-card'), true));
            }
          });
          paginationObserver.unobserve(paginationSection);
        }
      });
    }, {rootMargin: preloadMargin});
    // Watch pagination section
    paginationObserver.observe(document.querySelector('#collection-pagination'));

    // Load more
    loadMoreButton.click(function() {

      $('body').css('overflow-anchor', 'none'); // Ensure scroll position maintains

      $('.grid-item.revealed').removeClass('revealed');

      // Update progress bar
      pagProgress.addClass('active');
      updateProgressBar();

      setTimeout( function() {
        $('.grid-item.new').show(); // show space

        $('.grid-item.new').each( function(i) {
          // Reveal each loaded card in sequence
          var thisItem = $(this);
          setTimeout( function() {
            thisItem.addClass('revealed').removeClass('new');
          }, 100 + (i*80));
          // Remove revealed class due to style restrictions with transform property and fixed overview video overlay
          setTimeout( function() {
            thisItem.removeClass('revealed');
          }, 1000 + (i*80));
        });

        productsViewed.text(countProductsLoaded());

        // pagProgress.removeClass('active'); // Reset progress bar state
        pagProgress.removeClass('active'); // Reset progress bar state
        // Update pagination data
        currentPageIndex++;
        pageToFetch = nextPageUrl.split("=")[0] + "=" + (currentPageIndex + 1) + "&" + urlParams;
        pagSection.attr('data-next-page-url', pageToFetch);
        // If pagination complete, apply feedback
        if (currentPageIndex == pagTotalPages) {
          loadMoreButton.fadeOut();
          // Check if filters are applied to collection
          if ($('#collection-pagination').attr('data-filter-applied') == 'true') {
            filterAppliedLink = ' with <a href="javascript:;" class="applied-filters">applied filters</a>';
          }
          pagSection.find('p').html('Viewing all ' + collectionTotalProducts + ' items in this ' + collectionType + filterAppliedLink);
        }
        // Update pseudo page parameter in URL
        updateUrlPageParam(currentPageIndex);
        // Continue observing pagination section after load
        paginationObserver.observe(document.querySelector('#collection-pagination'));

      }, 600); // time for bar animation

    }); // end click

  }

  // MANUAL LOAD ON CLICK
  else { // If Intersection Observer isn't supported

    loadMoreButton.click(function() {
      $('body').css('overflow-anchor', 'none'); // Ensure scroll position maintains
      // Update progress bar
      pagProgress.addClass('active');
      updateProgressBar();
      // Get data from next page of products
      $.ajax({
        url: pageToFetch,
        success: function(result) {
          // Find product-cards from next page and append
          let newItems = $(result).find('.product-card');
          newItems.each( function(i) {
            let newItem = $(newItems[i]).wrap( "<div class='grid-item'></div>" ); // Wrap each product-card in a grid-item
            // $(newItem.parent()).insertBefore($("#collection-pagination")); // Append new wrapped item to the list before pagination section
            $("#collection-listing").find('.grid').append($(newItem.parent())); // Append new wrapped item to the grid
            wishlistBtnState($(newItems[i]).find('.wishlist-add'));
          });
          // Update products-viewed text in pagination section
          productsViewed.text(countProductsLoaded());
        }
      }).done(function() {
        lazyImages();
        // Generate payment plan hooks for all new items
        let productPaymentPlanHooks = document.querySelectorAll('.product-payment-plan-hook.loading');
        if(productPaymentPlanHooks.length > 0) {
          productPaymentPlanHooks.forEach((hook) => makeProductHummHook(hook));
        }
        // Apply event listeners for all new product overview videos
        let newGridItems = document.getElementById('collection-listing').querySelectorAll('.grid-item');
        if(newGridItems.length > 0) {
          newGridItems.forEach((newGridItem) => productCardOverviewVideo(newGridItem.querySelector('.product-card'), true));
        }
        // pagProgress.removeClass('active'); // Reset progress bar state
        pagProgress.removeClass('active'); // Reset progress bar state
        // Update pagination data
        currentPageIndex++;
        pageToFetch = nextPageUrl.split("=")[0] + "=" + (currentPageIndex + 1) + "&" + urlParams;
        pagSection.attr('data-next-page-url', pageToFetch);
        // If pagination complete, apply feedback
        if (currentPageIndex == pagTotalPages) {
          loadMoreButton.fadeOut();
          // Check if filters are applied to collection
          if ($('#collection-pagination').attr('data-filter-applied') == 'true') {
            filterAppliedLink = ' with <a href="javascript:;" class="applied-filters">applied filters</a>';
          }
          pagSection.find('p').html('Viewing all ' + collectionTotalProducts + ' items in this ' + collectionType + filterAppliedLink);
        }
        // Update pseudo page parameter in URL
        updateUrlPageParam(currentPageIndex);
      });

    }); // end click

  }

  // Open filter drawer from applied filters link (in pagination section)
  $('#collection-pagination').on('click', '.applied-filters', function(e) {
    $('#filter-drawer').addClass('active');
    $('#filter-drawer .drawer-header .close-btn').addClass('highlight'); // One-time highlight of close button (mobile only)
  });


}

// Only call the above where collection has pagination
if ($('#collection-pagination').length) {
  collectionPagination();
}
